import __var_0__ from './main.js';
/**

*
* Copyright (c) 2020 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Create an iterator which generates a sequence of positive even integers.
*
* @module @stdlib/math/iter/sequences/positive-even-integers
*
* @example
* var iterPositiveEvenIntegersSeq = require( '@stdlib/math/iter/sequences/positive-even-integers' );
*
* var iter = iterPositiveEvenIntegersSeq();
*
* var v = iter.next().value;
* // returns 2
*
* v = iter.next().value;
* // returns 4
*
* v = iter.next().value;
* // returns 6
*
* // ...
*/

// MODULES //
var iterator = __var_0__;


// EXPORTS //
export default iterator;
